// Per-theme skin for the Opportunities pages (s153): one expanded layout on
// every brand — Moderno (Acapital, approved s140-141), Personal Brand Pro
// (Carlos) and Private Community Pro (Aurex) only swap fonts, dark panel,
// accent strength and corner radius (mirrors BrandPage SKINS). Exposed as CSS
// vars on the page root; colours stay CMS tokens.
const SKINS = {
  modern: { head: "'Playfair Display', Georgia, serif", body: 'inherit', dark: '#16171a', strong: 'var(--accent-strong, #b86500)', radius: '3px' },
  personalbrand: { head: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Plus Jakarta Sans', 'Inter', sans-serif", dark: 'var(--color-footer-bg, #111111)', strong: 'var(--color-accent, #C9A24B)', radius: '12px' },
  // s158: opportunity mini-sites — monochrome so any client brand fits.
  minisite: { head: "'Geist', 'Inter', sans-serif", body: "'Geist', 'Inter', sans-serif", dark: '#141416', strong: 'var(--ms-accent, #141416)', radius: '10px' },
  privatecommunity: { head: "'Sora', 'Inter', sans-serif", body: "'Inter', sans-serif", dark: 'var(--color-primary, #1a2332)', strong: 'var(--color-accent, #73af5f)', radius: '10px' },
};

export function opportunitySkin(theme) {
  const onMinisite = typeof document !== 'undefined' && !!document.documentElement.dataset.minisite;
  const k = (onMinisite && SKINS.minisite) || SKINS[theme] || SKINS.privatecommunity;
  return { '--op-head': k.head, '--op-body': k.body, '--op-dark': k.dark, '--op-strong': k.strong, '--op-radius': k.radius, fontFamily: k.body };
}
